var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition-group",
    { attrs: { name: "list", appear: "" } },
    _vm._l(_vm.progressSorted, function(member) {
      return _c("div", { key: member.member }, [
        _c("div", { attrs: { id: "member-section" } }, [
          _c("div", { staticClass: "member" }, [_vm._v(_vm._s(member.member))]),
          _vm._v(" "),
          _c("div", [
            _c("img", {
              staticClass: "star",
              class: [
                { pinned: _vm.settings.work.pin === member.member },
                { unpinned: _vm.settings.work.pin !== member.member }
              ],
              attrs: { src: require("../../assets/star-blue-24px.svg") },
              on: {
                click: function($event) {
                  return _vm.updatePin(member.member)
                }
              }
            }),
            _vm._v(" "),
            _vm.settings.work.queue
              ? _c("img", {
                  staticClass: "filter",
                  class: [
                    { filtered: _vm.settings.work.filter === member.member },
                    { unfiltered: _vm.settings.work.filter !== member.member }
                  ],
                  attrs: {
                    src: require("../../assets/filter_list_blue_24dp.svg")
                  },
                  on: {
                    click: function($event) {
                      return _vm.updateFilter(member.member)
                    }
                  }
                })
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "queue" },
          _vm._l(member.cards, function(card) {
            return _c("div", { key: card.id }, [
              _c("a", { attrs: { href: card.link, target: "_blank" } }, [
                _c(
                  "div",
                  {
                    staticClass: "card card-progress",
                    class: [
                      {
                        neutral:
                          _vm.defaultZero(card.progress_days) <
                            _vm.oldThreshold &&
                          _vm.defaultZero(card.progress_days) > _vm.newThreshold
                      },
                      {
                        new:
                          _vm.defaultZero(card.progress_days) <=
                          _vm.newThreshold
                      },
                      {
                        old:
                          _vm.defaultZero(card.progress_days) >=
                          _vm.oldThreshold
                      }
                    ]
                  },
                  [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(_vm._s(card.contract))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "card-name" }, [
                      _vm._v(_vm._s(_vm.shortName(card.name)))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "timestamp-progress" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatTimestamp(card.progress_first_seen, "month")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _vm.settings.global.dots
                      ? _c(
                          "div",
                          { staticClass: "days" },
                          _vm._l(
                            _vm.dots(_vm.defaultZero(card.progress_days)),
                            function(n, i) {
                              return _c("div", { key: i }, [
                                _c("div", {
                                  domProps: { innerHTML: _vm._s(n) }
                                })
                              ])
                            }
                          ),
                          0
                        )
                      : _c("div", { staticClass: "days" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.defaultZero(card.progress_days)) +
                              "\n            "
                          )
                        ]),
                    _vm._v(" "),
                    _vm.settings.work.icons
                      ? _c("div", { staticClass: "icon" }, [
                          card.platform == "trello"
                            ? _c("img", {
                                staticClass: "icon-img",
                                attrs: {
                                  src: require("../../assets/trello-icon.png")
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          card.platform == "zendesk"
                            ? _c("img", {
                                staticClass: "icon-img",
                                attrs: {
                                  src: require("../../assets/zendesk-icon.png")
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          card.platform == "jira"
                            ? _c("img", {
                                staticClass: "icon-img",
                                attrs: {
                                  src: require("../../assets/jira-icon.png")
                                }
                              })
                            : _vm._e()
                        ])
                      : _vm._e()
                  ]
                )
              ])
            ])
          }),
          0
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64dd422d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64dd422d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Work/WorkList.vue
// module id = null
// module chunks = 